var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-flex"},[_c('core-title',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var attrs = ref.attrs;
return [_c('core-goto',_vm._b({},'core-goto',attrs,false),[_vm._t("default")],2)]}}],null,true)},'core-title',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }